module.exports = {
  i18n: {
    defaultLocale: 'en',
    locales: ['en', 'cs', 'de', 'fr', 'es', 'it', 'pl', 'sk'],
  },
  trailingSlash: true,
};
